import React, { useState, useEffect } from 'react';
import * as Assets from '../../utils/svg_assets';
import PreviewResult from './result';
import styled from 'styled-components';

const PreviewImage = (props) => {
  const { payload, onTakePhoto, images, onCancel = () => {} } = props;
  const { img, img2 } = payload;
  const [file, setFile] = useState();
  const [isPreviewResult, setIsPreviewResult] = useState(false);

  useEffect(() => {
    if (images && images.length) {
      setFile(URL.createObjectURL(images[images.length - 1].image));
    }
  }, [img]);

  return (
    <div className="h-100">
      <CloseButtonContainer>
        <button className="close-button">
          <img
            src={Assets.iconClose}
            alt="Icon Close"
            onClick={() => onCancel(false)}
          />
        </button>
      </CloseButtonContainer>

      {isPreviewResult ? (
        <PreviewResult
          payload={payload}
          onCancel={() => setIsPreviewResult(false)}
        />
      ) : (
        <>
          {(images.length === 1 || images.length === 2) && (
            <RoundedButtonContainer>
              {images.length === 1 && (
                <button className="rounded-button-orange">
                  <span className="number">1</span>
                </button>
              )}
              {images.length === 2 && (
                <>
                  <button className="rounded-button-white">
                    <span className="number">1</span>
                  </button>
                  <button className="rounded-button-orange">
                    <span className="number">2</span>
                  </button>
                </>
              )}
            </RoundedButtonContainer>
          )}
          <div className="card">
            <img src={file} alt="Preview Image" className="preview" />
          </div>
          <div className="footer-add-photo">
            <div className="d-flex wrapper-tab align-items-center p-0 overflow-none justify-content-around">
              <div onClick={() => onTakePhoto('retry')}>Retry</div>
              <div
                className="add-photo-container"
                onClick={() => onTakePhoto('add')}
              >
                {images.length < 2 ? (
                  <div>
                    <img
                      src={`${Assets.iconPlusOrange}`}
                      className="icon-add-photo"
                      alt="Plus Orange"
                    />
                  </div>
                ) : (
                  <></>
                )}
                {images.length < 2 ? (
                  <div className="text-title-main-color-xs">Add a photo</div>
                ) : (
                  <></>
                )}
              </div>
              <div onClick={() => setIsPreviewResult(true)}>Preview</div>
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default PreviewImage;

const CloseButtonContainer = styled.div`
  padding: 10px;
  position: absolute;
  top: 0;
  right: 0;
  z-index: 2;
  width: 100%;
  .close-button {
    cursor: pointer;
    background: transparent;
    border: none;

    &:focus {
      outline: none;
      border: none;
    }
    img {
      width: 15px;
      height: 15px;
    }
  }
`;

const RoundedButtonContainer = styled.div`
  position: absolute;
  top: 50px; /* Adjust based on the height of the close button */
  right: 10px; /* Adjust as needed */
  z-index: 1;
  display: flex;
  gap: 4px;
  .rounded-button-orange {
    cursor: pointer;
    background: transparent;
    border: none;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 30px; /* Adjust size */
    height: 30px; /* Adjust size */
    border-radius: 50%; /* Circle shape */
    background-color: var(--main-color); /* Background color */

    .number {
      color: white; /* Text color */
      font-size: 14px; /* Text size */
      font-weight: bold; /* Text weight */
    }

    &:focus {
      outline: none;
      border: none;
    }
  }
  .rounded-button-white {
    cursor: pointer;
    background: transparent;
    border: none;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 30px; /* Adjust size */
    height: 30px; /* Adjust size */
    border-radius: 50%; /* Circle shape */
    background-color: #d3d3d3; /* Background color */

    .number {
      color: black; /* Text color */
      font-size: 14px; /* Text size */
      font-weight: bold; /* Text weight */
    }

    &:focus {
      outline: none;
      border: none;
    }
  }
`;
